import BigNumber from 'bignumber.js'
import React, { useCallback, useMemo, useState } from 'react'
import Web3 from 'web3'
import styled from 'styled-components'
import { Button, Modal, Text } from '@pancakeswap-libs/uikit'
import Input from 'components/Input'
import useI18n from 'hooks/useI18n'
import { useCheckLiquidityGeneratorWhiteList } from '../hooks/useSep20Factory'

interface ModalProps {
  tokenAddress: any
  onDismiss?: () => void
}

const TheModal: React.FC<ModalProps> = ({ tokenAddress, onDismiss }) => {
  const TranslateString = useI18n()

  const [value, setNewValue] = useState('')
  const [address, setNewAddress] = useState('')
  const handleChange = (e: React.FormEvent<HTMLInputElement>) => {
    setNewValue(e.currentTarget.value);
    if (Web3.utils.isAddress(e.currentTarget.value)) {
      setNewAddress(e.currentTarget.value);
    } else {
      setNewAddress('');
    }
  }

  const isWhitelisted = useCheckLiquidityGeneratorWhiteList(tokenAddress, address);

  return (
    <Modal title="Check Whitelist" onDismiss={onDismiss}>
      <div>
        <Announce>
          There will be no transaction fee if either the sender or the receiver is in the whitelist.
        </Announce>
      </div>
      <Input placeholder="Address" value={value} onChange={handleChange} />
      {
        !!address && (
          <div>
            <Announce2>
              Address is {isWhitelisted ? "" : "not "}in the whitelist.
            </Announce2>
          </div>
        )
      }
    </Modal>
  )
}

export default TheModal

const Announce = styled(Text)`
  margin-bottom: 1em;
  text-align: left;
  max-width: 470px;
`

const Announce2 = styled(Text)`
  margin-top: 1em;
  text-align: center;
  max-width: 470px;
`
